import { IconPropsType } from '..';

export const NewNotificationIndicatorIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="4"
    height="4"
    viewBox="0 0 4 4"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="2"
      cy="2"
      r="2"
      fill="#4DB357"
    />
  </svg>
);
